import { useOrganizationContext } from "../../api/current-organization/organizationContext";
import Card from "../../components/Card";
import PaginationControls from "../../components/PaginationControls";
import TalentSummaryCard from "../../components/TalentSummaryCard";
import Typography from "../../components/Typography";
import { TalentSummary } from "../../models/app/talent";
import { useFindTalentContext } from "./findTalentContext";
import { TalentListSkeleton } from "./TalentListSkeleton";

export type TalentsListProps = {
    talents: TalentSummary[]
    isLoading: boolean
}

const TalentsList = ({ talents, isLoading }: TalentsListProps) => {
    const { talentTerminologyPlural } = useOrganizationContext();
    const {
        pageIndex,
        setPageIndex,
        pageSize,
        totalCount,
        totalPages,
        hasPreviousPage,
        hasNextPage,
    } = useFindTalentContext();

    const paginationProps = {
        pageIndex,
        setPageIndex,
        pageSize,
        totalCount,
        totalPages,
        hasPreviousPage,
        hasNextPage,
        itemName: talentTerminologyPlural
    };

    if (isLoading) return <TalentListSkeleton />;

    if (!isLoading && talents.length === 0) {
        return (
            <Card className="w-full self-start">
                <Typography variant="title-large" component="p">No results</Typography>
            </Card>
        );
    }

    return (
        <div className="space-y-8 w-full">
            {/* Top pagination controls */}
            <PaginationControls
                {...paginationProps}
                className="mb-6"
            />
            {talents.map(talent => (
                <TalentSummaryCard key={talent.id} talent={talent} />
            ))}
            {/* Bottom pagination controls */}
            <PaginationControls
                {...paginationProps}
                className="mt-8"
            />
        </div>
    );
};

export default TalentsList;